<!-- src/pages/MyPage.vue -->
<script setup>
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { addContentLogAPI } from '@/api/logServiceApi';
import InquiryWriteComponent from '@/components/board/BoardWriteInquiry.vue';
import ConfirmComponent from '@/components/common/Confirm.vue';
import MobileHeader from '@/components/common/MobileHeader.vue';

definePage({ meta: { layout: 'mypage' } });

const route = useRoute();
const router = useRouter();
const store = useStore();

const isWebView = ref(false);

/** 이전 페이지 검사 */
function hasBackNow() {
  const st = window.history.state || null;
  if (st && typeof st.position === 'number') return st.position > 0;
  if (st && st.back != null) return true;
  return false;
}

/** 뒤로가기 핸들러 */
const handleBack = () => {
  if (hasBackNow()) {
    router.back();
  } else {
    router.push('/main');
  }
};
const userId = ref(null);
userId.value = store.getters['user/id'];

// dialog 문구
const dialogTitle = ref('');
const dialogTitle2 = ref('');
const dialogText = ref('');
const dialogNextUrl = ref(null);
// dialog 컴포넌트 참조
const confirmRef = ref(null);

const showConfirm = ({ title, title2 = '', text = '', onConfirm = () => {} }) => {
  dialogTitle.value = title;
  dialogTitle2.value = title2;
  dialogText.value = text;
  dialogNextUrl.value = onConfirm;
  confirmRef.value?.openConfirmDialog();
};

/** 로그인 알림창 표시 */
const showLoginConfirm = () => {
  showConfirm({
    title: '로그인 후',
    title2: '이용가능합니다.',
    text: '로그인',
    onConfirm: () =>
      router.push({
        path: '/auth/login',
        query: {
          to: route.path,
          toQuery: JSON.stringify(route.query),
        },
      }),
  });
};
onMounted(() => {
  // 1:1 문의 페이지 진입 로그 (신규 type, DB 등록 후 작동)
  addContentLogAPI('MY_inquiry_view');
  isWebView.value = !!window.ReactNativeWebView;
  if (!userId.value) {
    showLoginConfirm();
  }
});
</script>

<template>
  <div class="my-info-wrap">
    <MobileHeader
      title="문의/신청"
      :show-back="isWebView"
      :show-menu="!isWebView"
      @back="handleBack"
    />
    <div class="my-tit-box com-bg-my-box h-small">
      <div class="tit fnt-big">문의/신청</div>
      <div class="path">
        <ul>
          <li>홈</li>
          <li>마이페이지</li>
          <li>문의/신청</li>
          <li>문의/신청</li>
        </ul>
      </div>
    </div>
    <InquiryWriteComponent @showLoginConfirm="showLoginConfirm" />
  </div>

  <ConfirmComponent
    ref="confirmRef"
    :title="dialogTitle"
    :title2="dialogTitle2"
    :text="dialogText"
    :nextUrl="dialogNextUrl"
  />
</template>
<style>
.mypage-body .board-inquiry-box {
  display: none;
}
.mypage-body .board-tit-box {
  display: none;
}
@media (max-width: 768px) {
  .my-info-wrap {
    padding-top: calc(52px + var(--safe-area-top, 0px));
    padding-bottom: var(--safe-area-bottom, 0px);
  }
  .my-tit-box {
    display: none;
  }
}
</style>
